<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Requisiciones Departamento</span>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="mb-2"
              @click="initialize"
              small
              rounded
            >
              Actualizar
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row justify="space-between">
              <v-col cols="12" md="6">
                <v-radio-group
                  v-model="opciones"
                  row
                >
                  <v-radio
                    label="Abierta"
                    :value="0"
                    color="red"
                  ></v-radio>
                  <v-radio
                    label="Aprobada"
                    :value="1"
                    color="orange"
                  ></v-radio>
                  <v-radio
                    label="Rechazada"
                    :value="2"
                    color="black"
                  ></v-radio>
                  <v-radio
                    label="Completa"
                    :value="3"
                    color="green"
                  ></v-radio>
                  <v-radio
                    label="Pre Autorizada"
                    :value="4"
                    color="grey"
                  ></v-radio>
                  <v-radio
                    label="Todas"
                    :value="5"
                    color="primary"                   
                  ></v-radio>
                </v-radio-group>
              </v-col>


              <v-col cols="12" md="6" lg="4">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                  rounded
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="filterRequisiciones"
                  class="elevation-0"
                  :search="search"
                  :page.sync="page"
                  @page-count="pageCount = $event"
                  :mobile-breakpoint="100"
                  hide-default-footer
                  dense
                >
                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.activo_sn="{ item }">
                    <v-chip 
                      v-if="item.activo_sn == 1"
                      small
                      color="green"
                      dark
                    >Si</v-chip>

                    <v-chip 
                      v-else
                      small
                      color="error"
                      dark
                    >No</v-chip>
                  </template>

                  <template v-slot:item.estatus="{ item }">
                    <v-chip color="red"    dark small v-if="item.estatus == 0">Abierta</v-chip>
                    <v-chip color="orange" dark small v-if="item.estatus == 1">Aprobada</v-chip>
                    <v-chip color="black"  dark small v-if="item.estatus == 2">Rechazada</v-chip>
                    <v-chip color="green"  dark small v-if="item.estatus == 3">Completa</v-chip>
                    <v-chip color="grey"   dark small v-if="item.estatus == 4">Pre Autorizada</v-chip>
                  </template>
                

                  <template v-slot:item.actions="{ item }">
                    <v-btn 
                      color="primary" 
                      x-small
                      @click="editItem(item)"
                      class="mr-2"
                    >
                      <v-icon small>mdi-magnify</v-icon>
                    </v-btn>

                    <v-btn 
                      v-if="item.estatus == 0"
                      color="error" 
                      x-small
                      @click="deleteItem(item)"
                      class="mr-2"
                    >
                      <v-icon small> mdi-delete</v-icon>
                    </v-btn>

                    <v-btn 
                      color="orange" 
                      dark
                      x-small
                      @click="dialogCorreo = true, requisicion = item "
                      class="mr-2"
                    >
                      <v-icon small>mdi-email</v-icon>
                    </v-btn>

                    <v-btn 
                      v-if="[1,3].includes( item.estatus )"
                      color="grey" 
                      x-small
                      dark
                      @click="verPdf(item)"
                      class="mr-2"
                    >
                      <v-icon small>mdi-download</v-icon>
                    </v-btn>

                    <v-btn 
                      color="green" 
                      dark
                      x-small
                      @click="requisicion = item , paramsNotas.estatus = true"
                      class="mr-2"
                    >
                      <v-icon small>mdi-message</v-icon>
                    </v-btn>

                  </template>

                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                      small
                    >
                      Actualizar
                    </v-btn>
                  </template>

                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>ID: RQ-RC-CO-09-{{ editedItem.idrequisiciones }}</strong>
          </span>
        </v-card-title>


        <v-card-text class="black--text">
          <b>Departamento Solicitante:</b> 
            {{ editedItem.departamento }}
          <br/>
          <b>Solicitado por:</b> 
            {{ editedItem.solicito }}
          <br/>

          <b v-if="[1,3].includes( editedItem.estatus )">Aprobado por:</b> 
            {{ editedItem.aprobo }}
          <br v-if="[1,3].includes( editedItem.estatus )"/>

          <b v-if="[1,3].includes( editedItem.estatus )">Fecha aprobación:</b> 
            {{ editedItem.aprobada_fecha }}
          <br v-if="[1,3].includes( editedItem.estatus )"/>

          <v-subheader class="pl-0 black--text mt-4">
            Artículos
          </v-subheader>
          <v-data-table
            :headers="headersArticulos"
            :items="articulos"
            class="shadowCard"
            :mobile-breakpoint="100"
            dense
          >

            <template v-slot:item.actions="{ item }" v-if="editedIndex === -1">
              <v-btn 
                color="primary" 
                x-small
                @click="editItemArt(item)"
                class="mr-2"
              >
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>

              <v-btn 
                color="error" 
                x-small
                @click="deleteItemArt(item)"
                class="mr-2"
              >
                <v-icon small> mdi-delete</v-icon>
              </v-btn>
            </template>

            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="initialize"
                small
              >
                Actualizar
              </v-btn>
            </template>
          </v-data-table>

          <v-subheader class="pl-0 black--text">
            Tabla comparativa
          </v-subheader>
         
          <v-data-table
            :headers="headersProveedores"
            :items="proveedores"
            class="shadowCard"
            :mobile-breakpoint="100"
            dense
          >
            <template v-slot:item.actions="{ item }" v-if="editedIndex === -1">
              <v-btn 
                color="primary" 
                x-small
                @click="editItemProve(item)"
                class="mr-2"
              >
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>

              <v-btn 
                color="error" 
                x-small
                @click="deleteItemProvee(item)"
                class="mr-2"
              >
                <v-icon small> mdi-delete</v-icon>
              </v-btn>
            </template>

            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="initialize"
                small
              >
                Actualizar
              </v-btn>
            </template>

          </v-data-table>

          <v-card class="shadowCard mt-6">
            <v-textarea
              v-model="editedItem.notas"
              label="Notas"
              filled
              rows="3"
              hide-details
            ></v-textarea>
          </v-card>

        </v-card-text>

        <v-card-actions>
          <v-btn
            color="red"
            dark
            dense
            rounded
            small
            @click="close"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            dark
            dense
            rounded
            small
            @click="updateRequisicion( 2 )"
            v-if="[0].includes( editedItem.estatus )"
            class="mr-2"
          >
            Rechazar
          </v-btn>

          <v-btn
            color="grey"
            dark
            dense
            rounded
            small
            @click="updateRequisicion( 4 )"
            v-if="[0].includes( editedItem.estatus )"
          >
            Pre Autorizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar el departamento?
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
                    <v-btn color="error" text  class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
                    <!-- Guardar la información  -->
                    <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogCorreo"
      persistent
      max-width="400"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Enviar requisición al correo: 
        </v-card-title>
        <v-card-text>
          <v-text-field
            filled
            type="mail"
            label="Correo"
            v-model="correo"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            rounded
            @click="dialogCorreo = false, requisicion = null, correo = null"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            small
            rounded
            @click="enviarCorreo()"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

    <NotasRequi  v-if="paramsNotas.estatus == true" :paramsNotas="paramsNotas" :requisicion="requisicion"/>


  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import NotasRequi            from '@/components/requisiciones/NotasRequi.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
    components:{
      Alerta,
      carga,
      NotasRequi
    },

    mixins: [ validarErrores ],
    
    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idrequisiciones:0,
        estatus:'',
        aprobada_usuario: 0,
        notas:''
      },

      defaultItem: {
        idrequisiciones:0,
        estatus:'',
        aprobada_usuario: 0,
        notas:''
      },

      // Filtros: 
      incio:null,
      fin:null,

      // tabla
      search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      departamentos: [],
      headers: [
        { text: 'ID'           , value: 'idrequisiciones' },
        { text: 'Solicitó'     , value: 'solicito'        },
        { text: 'Usuario'      , value: 'usuario'         },
        { text: 'Estatus'      , value: 'estatus'         },
        { text: 'Fecha'        , value: 'fecha_creacion'  },
        { text: 'Departamento' , value: 'departamento'    },
        { text: 'Actions'      , value: 'actions', sortable: false },
      ],

      headersArticulos:[
        { text: 'Partida'      , value: 'partida'     },
        { text: 'Cantidad'     , value: 'cantidad'    },
        { text: 'Unidad'       , value: 'unidad'      },
        { text: 'Descripción'  , value: 'descripcion' },
        { text: 'Orden Compra' , value: 'orden_compra'},
      ],
      articulos:[],

      headersProveedores:[
        { text: 'Partida'      , value: 'partida'          },
        { text: 'Proveedor'    , value: 'proveedor'        },
        { text: 'Especifica.'  , value: 'especificaciones' },
        { text: 'Comentarios'  , value: 'comentarios'      },
        { text: 'Precio Coti.' , value: 'precio_cotizado'  },
      ],
      proveedores:[],
      dialogArticulos: false,
      dialogProveedores: false,
      requisiciones:[],

      correo: null,
      requisicion: null,
      dialogCorreo: false,
      opciones: 5,

      paramsNotas:{
        estatus: false,
      },
    }),

    computed: {
      ...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar Requisición' : 'Editar el Requisición'
      },

      filterRequisiciones( ){
        if( this.opciones == 5 ){
          return this.requisiciones
        }else{
          return this.requisiciones.filter( el => { return el.estatus == this.opciones })
        }
      }

    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    async created () {
      console.log( this.getdatosUsuario ) 
      await this.initialize()
    },

    methods: {
      initialize () {
        this.cargar = true
        this.requisiciones = []
        return this.$http.get('requisiciones.departamento/' + this.getdatosUsuario.id ).then(response=>{
          this.requisiciones = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.requisiciones.indexOf(item)
        this.editedItem  = Object.assign({}, item)
        this.articulos   = this.editedItem.articulos
        this.proveedores = this.editedItem.proveedores
        this.dialog      = true
      },

      deleteItem (item) {
        this.editedIndex = this.requisiciones.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('requisiciones.update/' + this.editedItem.idrequisiciones, this.editedItem).then(response=>{
          this.cargar = true
          this.closeDelete()
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      updateRequisicion( value ){
        const payload = {
          aprobada_usuario : value != 2 ? this.getdatosUsuario.id : null,
          estatus          : value,
        } 

        this.cargar = true

        // Lo mandapos por el EP
        this.$http.put('requisiciones.update/' + this.editedItem.idrequisiciones, payload ).then(response=>{
          this.close()
          this.validarSuccess( response.body.message )
          this.initialize()
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      verPdf( value ){
        this.cargar = true
        // Lo mandapos por el EP
        this.$http.post('requisiciones.generar', value ).then(response=>{
          this.cargar = false
          window.open( this.$http.options.root + `requisiciones.pdf/RQ-RC-CO-09-${value.idrequisiciones}.pdf` )
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      enviarCorreo( ){
        if( !this.correo ){ return this.validarErrorDirecto('Por favor, ingresa un correo') }

        const payload = {
          correo         : this.correo,
          idrequisiciones: this.requisicion.idrequisiciones,
          requisicion    : this.requisicion
        }

        this.cargar = true
        // Lo mandapos por el EP
        this.$http.post('enviar.requisicion', payload ).then(response=>{
          this.validarSuccess( response.body.message )
          this.dialogCorreo = false
          this.correo       = null
          this.requisicion  = null
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      }
    },
  }
</script>

